var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12548_34311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3198 9.33594V11.9806C12.3198 12.3313 12.1837 12.6676 11.9413 12.9156C11.6989 13.1635 11.3701 13.3029 11.0274 13.3029H1.97998C1.63719 13.3029 1.30845 13.1635 1.06606 12.9156C0.823672 12.6676 0.6875 12.3313 0.6875 11.9806V9.33594",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.27344 6.02734L6.50464 9.33311L9.73584 6.02734",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8.63309V0.699219",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12548_34311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBlack);
export default __webpack_public_path__ + "static/media/DownloadBlack.e1163dd1f15ab60cb3327beedc989789.svg";
export { ForwardRef as ReactComponent };